import {
  FETCH_BRAND_HS_CUSTOM_FIELDS_START,
  FETCH_BRAND_HS_CUSTOM_FIELDS_SUCCESS,
  FETCH_BRAND_HS_CUSTOM_FIELDS_FAILURE,
  SAVE_BRAND_HS_CUSTOM_FIELDS_START,
  SAVE_BRAND_HS_CUSTOM_FIELDS_SUCCESS,
  SAVE_BRAND_HS_CUSTOM_FIELDS_FAILURE,
  RESET_BRAND_HS_CUSTOM_FIELDS_SAVE,
} from '../constants/brandHsCustomFieldsTypes'

const INITIAL = {
  fetch: { loading: false, success: null, data: null, errors: null },
  save: { loading: false, success: null, data: null, errors: null },
}

export default function reducer(state = INITIAL, action) {
  switch (action.type) {
    case FETCH_BRAND_HS_CUSTOM_FIELDS_START:
      return {
        ...state,
        fetch: { loading: true, success: null, data: state.fetch.data, errors: null },
      }
    case FETCH_BRAND_HS_CUSTOM_FIELDS_SUCCESS:
      return {
        ...state,
        fetch: { loading: false, success: true, data: action.data, errors: null },
      }
    case FETCH_BRAND_HS_CUSTOM_FIELDS_FAILURE:
      return {
        ...state,
        fetch: { loading: false, success: false, data: state.fetch.data, errors: action.errors },
      }

    case SAVE_BRAND_HS_CUSTOM_FIELDS_START:
      return {
        ...state,
        save: { loading: true, success: null, data: null, errors: null },
      }
    case SAVE_BRAND_HS_CUSTOM_FIELDS_SUCCESS:
      return {
        ...state,
        save: { loading: false, success: true, data: action.data, errors: null },
        fetch: { ...state.fetch, data: { ...state.fetch.data, ...action.data } },
      }
    case SAVE_BRAND_HS_CUSTOM_FIELDS_FAILURE:
      return {
        ...state,
        save: { loading: false, success: false, data: null, errors: action.errors },
      }
    case RESET_BRAND_HS_CUSTOM_FIELDS_SAVE:
      return { ...state, save: INITIAL.save }

    default:
      return state
  }
}
